// extracted by mini-css-extract-plugin
export default {"button":"Countdown_button__-P08I","container":"Countdown_container__fdhZt","dial":"Countdown_dial__wVBih"};